// worker.js
const workercode = () => {

	let size = 0;

	self.onmessage = function(e) {

		// CREATE THE BLOB FROM ENCODED JPEG IMAGE DATA AND SET UP THE FILE READER
		let blob = new Blob( [ e.data.blob ], { type: "image/jpeg" }),
			reader = new FileReader();

		size += blob.size;

		// SEND MESSAGE WITH NEW BASE64 IMAGE BACK TO MAIN THREAD
		reader.onloadend = function() {

			self.postMessage( {
				position: e.data.position || 0,
				image: reader.result,
				blobby: blob
			});
		};

		// READ BLOB FILE AS BASE 64 URL
		reader.readAsDataURL(blob);
	}
};

let code = workercode.toString();

code = code.substring(code.indexOf("{")+1, code.lastIndexOf("}"));

const blob = new Blob([code], {type: "application/javascript"});

const worker_script = URL.createObjectURL(blob);

module.exports = worker_script;


// WEBPACK FOOTER //
// ./src/app/utils/worker-image.js